// extracted by mini-css-extract-plugin
export default {"buttonVoltar":"ButtonVoltar_buttonVoltar__+LwR2"};